export const submitCaptcha = () =>{
    console.log('running captcha')
    return new Promise((resolve, reject) => {
        console.log('running captvha')
        const intervalID = setInterval(()=>{
            console.log(window.grecaptcha)
            if (!window.grecaptcha) return
            console.log('captcha is ready')
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
                .then(token => {
                    clearInterval(intervalID)
                    resolve(token)
                })
                .catch(e=>{
                    console.log(e)
                    clearInterval(intervalID)
                    reject(e)
                })
            });
        }, 1000)
    })
}